import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import LoadingPage from "../components/LoadingPage";
import Header from "../components/Header";

export const PrivateRoute = ({
  isAuthenticated,
  isVerified,
  loadingInProgress,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? (
        isVerified ? (
          <div className="route-container">
            {loadingInProgress && <LoadingPage />}
            <Header />
            <Component {...props} key={props.match.path} />
          </div>
        ) : (
          <Redirect to="/verify_email" />
        )
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

const mapStateToProps = state => ({
  isAuthenticated: !!state.auth.uid,
  isVerified: !!state.auth.is_verified,
  loadingInProgress: state.loadingInProgress
});

export default connect(mapStateToProps)(PrivateRoute);
